import { cn, Stack, StackProps } from 'component-library';
import { useTranslation } from 'react-i18next';

import { DefaultWidgetNames, WidgetType } from '@/api/rest/resources/types/widget';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useWidgetSlotConfigurationByNameType } from '@/hooks/useWidgetConfigurationByOrganizationId';

import { BiodiversityTile } from './components/BiodiversityTile';
import { AGCarbonTile, BGCarbonTile } from './components/CarbonTile';
import { NDVITile } from './components/NDVITile';
import { RisksTile } from './components/RisksTile';
import { SocialTile } from './components/SocialTile';
import { SoilTile } from './components/SoilTile';
import { WaterTile } from './components/WaterTile';

export const LandMonitoringPage = () => {
  const widgetSlotsConfiguration = useWidgetSlotConfigurationByNameType(
    DefaultWidgetNames.default_template_land_monitoring,
    WidgetType.t_page,
  );

  return (
    <Stack spacing={10} data-testid='landmonitoring-page'>
      <WidgetSlotRenderer nestedWidget={widgetSlotsConfiguration} />
      {/* <ProjectOverview /> TODO: MVP-6042 fill with information from https://thelandbankinggroup.slack.com/archives/C08JVD65EQ4/p1754637475913729 */}
      <NatureCapitalImprovements />
      <RisksTile />
    </Stack>
  );
};

const NatureCapitalImprovements = () => {
  const { t } = useTranslation();

  return (
    <>
      <span className='typography-h3'>{t('shared.ncaDetail.details.landMonitoring.natureCapitalImprovements')}</span>
      <div className='grid grid-cols-1 gap-10 lg:grid-cols-2'>
        <Card>
          <BGCarbonTile />
        </Card>
        <Card>
          <AGCarbonTile />
        </Card>
        <Card>
          <WaterTile />
        </Card>
        <Card>
          <BiodiversityTile />
        </Card>
        <Card>
          <NDVITile />
        </Card>
        <Card>
          <SoilTile />
        </Card>
        <Card>
          <SocialTile />
        </Card>
        {/*
        TODO: MVP-CW hiding from now, we don't have enough data for this
        <Card>
          <ForestStructureTile />
        </Card> */}
      </div>
    </>
  );
};

type CardProps = StackProps;

const Card = ({ className, ...delegated }: CardProps) => {
  return (
    <Stack className={cn('rounded-[32px] bg-white-100 p-8 border border-neutral-black-12', className)} {...delegated} />
  );
};
